<div class="jw-modal" style="padding-top: 0 !important; z-index: 10000;">
  <ng-content></ng-content>
</div>
<div class="jw-modal-background"></div>
